import { BatchHttpLink } from "apollo-link-batch-http";

import { GRAPHQL_ROOT } from "config/constants";

const apiLink = config =>
  new BatchHttpLink({
    uri: GRAPHQL_ROOT,
    ...(config || {}),
  });

export default apiLink;
